import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  circleFill?: string;
  textFill?: string;
}

export const KDotIcon = ({ circleFill = '#638BD9', textFill = '#fff', ...props }: Props) => (
  <svg viewBox="0 0 128 128" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle fill={circleFill} cx="64" cy="64" r="64" />
      <path
        d="M82.3864542,86.62 L75.812749,75.088 C73.9900398,71.978 72.3505976,71.154
    72.2589641,71.154 L72.2589641,71 L82.3864542,59 L88.4023904,59 L88.4023904,50.4
    L66.0916335,50.4 L66.0916335,59 L71.4880478,59 L63.9003984,68 L57.9243028,68 L57.9243028,32
    L39,32 L39,40.6 L46.3705179,40.6 L46.3705179,88.4 L39.5976096,88.4 L39.5976096,97
    L62.9043825,97 L62.9043825,88.4 L57.9243028,88.4 L57.9243028,76.4 L60.6713147,76.4
    C62.3207171,76.4 63.7868526,76.492 64.7011952,78.148 L73.1294821,92.948
    C74.9621514,96.348 76.5159363,96.994 80.4581673,96.994 L89,96.994 L89,88.4
    L86.2848606,88.4 C84.0936255,88.4 83.2768924,88.126 82.4561753,86.752"
        fill={textFill}
      />
    </g>
  </svg>
);
